
import React, { Component } from "react";
import { Modal } from "react-bootstrap";
import Navbar from "../../../components/Navbar.js";
import Select from "react-select";
import LOGO from "../../../assets/images/logo.png";
import SignatureCanvas from 'react-signature-canvas';
import {
    locale,
    tokens,
    select_style,
    required,
    // alert
    success,
    success_url,
    alert,
    alert_url,
    // function
    logout,
    number_zero,
    format_date,
    toFixed,
    total,
    validate,
    random_charactor,
    float,
    // api
    GET,
    POST,
    PUT,
    DELETE,
    error_message,
    // storage
    removeStorage,
    getStorage,

    validate_email,
    validate_th,
    validate_en,
    validate_en_number,

    LinktoBase64,
    // component
    DatePicker,
} from "../../../components/CustomComponent.js";

import "../../../components/global.js";
import "../../../assets/css/bootstrap.css";
import "../../../assets/css/index.css";

export default class Dashboard extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: false,

            role_name: "",
            role_description: "",
            role_detail: global.role
        };
    }
    componentDidMount() {
        if (this.props.location.query.id) {
            this.GetById(this.props.location.query.id)
        }
    }
    GetById = async (id) => {
        this.setState({ loading: true });
        let body = {
            page: this.state.page,
            data_search: this.state.data_search,
            role_id: id
        }
        let result = await GET(tokens, "v1/TH/role-manage/list/" + getStorage("branch").branch_id, body);
        if (result && result.status) {
            console.log(result)
            let role = this.state.role_detail;
            for (let data of result.data.permission) {
                role.find(e => {
                    if (e.menu_name === data.menu_name) {
                        e.can_view = data.can_view;
                        e.can_add = data.can_add;
                        e.can_edit = data.can_edit;
                        e.can_delete = data.can_delete;
                        e.can_download = data.can_download;
                        e.can_approved = data.can_approved;
                    }
                })
            }
            this.setState({
                role_name: result.data.role_name,
                role_description: result.data.role_description,
                role_detail: role,
            })
        }
        this.setState({ loading: false });
    }
    Create = async () => {
        if (validate(this.state, ["role_name"])) { return };
        this.setState({ loading: true });
        let body = {
            role_name: this.state.role_name,
            role_description: this.state.role_description,
            permission: this.state.role_detail.filter(e => !e.title).map((item) => {
                return {
                    menu_name: item.menu_name,
                    can_view: item.can_view,
                    can_add: item.can_add,
                    can_edit: item.can_edit,
                    can_delete: item.can_delete,
                    can_download: item.can_download,
                    can_approved: item.can_approved,
                };
            }),
        }
        let result = await POST(tokens, "v1/TH/role-manage/create/" + getStorage("branch").branch_id, body);
        if (result && result.status) {
            success_url("/master/list-role");
        }
        this.setState({ loading: false });
    }
    Update = async () => {
        if (validate(this.state, ["role_name"])) { return };
        this.setState({ loading: true });
        let body = {
            role_id: this.props.location.query.id,
            role_name: this.state.role_name,
            role_description: this.state.role_description,
            permission: this.state.role_detail.filter(e => !e.title).map((item) => {
                return {
                    menu_name: item.menu_name,
                    can_view: item.can_view,
                    can_add: item.can_add,
                    can_edit: item.can_edit,
                    can_delete: item.can_delete,
                    can_download: item.can_download,
                    can_approved: item.can_approved,
                };
            }),
        }
        let result = await PUT(tokens, "v1/TH/role-manage/update", body);
        if (result && result.status) {
            success_url("/master/list-role");
        }
        this.setState({ loading: false });
    }
    select_role = (type, index) => {
        let role = this.state.role_detail;
        if (type === "all") {
            role[index]["can_view"] = !role[index]["can_view"];
            role[index]["can_add"] = !role[index]["can_add"];
            role[index]["can_edit"] = !role[index]["can_edit"];
            role[index]["can_delete"] = !role[index]["can_delete"];
            role[index]["can_download"] = !role[index]["can_download"];
            role[index]["can_approved"] = !role[index]["can_approved"];
        } else {
            role[index][type] = !role[index][type];
        }
        this.setState({ role_detail: role })
    }
    select_all_role = (type, checked) => {
        let role = this.state.role_detail;
        if (type === "all") {
            for (let r of role) {
                if (r) {
                    r["can_view"] = checked;
                    r["can_add"] = checked;
                    r["can_edit"] = checked;
                    r["can_delete"] = checked;
                    r["can_download"] = checked;
                    r["can_approved"] = checked;
                }
            }
        } else {
            for (let r of role) {
                if (r) {
                    r[type] = checked;
                }
            }
        }
        this.setState({ role_detail: role })
    }
    render() {
        return (
            <div className="w-100 min-vh-100 fade-in">
                {this.state.loading && (<div className="spinner-container"> <div className="loading-spinner"></div> </div>)}
                <Navbar page1="หน้าหลัก" page2="แดชบอร์ด" />
                {/* BODY */}
                <div className="body bg-light min-vh-100 position-relative">
                    <div className="row">
                        <div className="col-11 col-md-10 col-lg-10 col-xl-8 mx-auto p-3">
                            {/* หัวข้อ และ ปุ่มเพิ่ม */}
                            <div className="d-flex mx-0 align-items-center justify-content-between test mb-2 flex-wrap">
                                <h3 className="mb-2"><b>จัดการบทบาท</b></h3>
                                <button className="btn btn-outline-orange mx-1" onClick={() => { window.location.href = "/master/list-role" }}>
                                    <span className="icon me-2">{"\uf060"}</span>ย้อนกลับ
                                </button>
                            </div>
                            {/* ด้านบน */}
                            <div className="w-100 p-3 card rounded border-0 mb-2">
                                {/* ชื่อบทบาท */}
                                <div className="d-flex row mx-0 align-items-center mb-2">
                                    <div className="wpx-120">
                                        <label>ชื่อบทบาท{required}:</label>
                                    </div>
                                    <div className="col-12 col-md-8 col-lg-6 col-xl-6">
                                        <input
                                            type="text"
                                            className="form-control validate"
                                            placeholder=""
                                            onChange={(e) => { this.setState({ role_name: e.target.value }); }}
                                            value={this.state.role_name}
                                        ></input>
                                    </div>
                                </div>
                                {/* รายละเอียด */}
                                <div className="d-flex row mx-0 align-items-center">
                                    <div className="wpx-120">
                                        <label>รายละเอียด:</label>
                                    </div>
                                    <div className="col-12 col-md-8 col-lg-6 col-xl-6">
                                        <textarea
                                            className="form-control validate"
                                            placeholder=""
                                            onChange={(e) => { this.setState({ role_description: e.target.value }); }}
                                            value={this.state.role_description}
                                        ></textarea>
                                    </div>
                                </div>
                            </div>
                            <div className="w-100" style={{ marginBottom: 100 }}>
                                <div className="card rounded-lg border-0 overflow-hidden">
                                    <div className="table-responsive">
                                        <table className="table table-borderless">
                                            <thead>
                                                <tr className="bg-primary text-white">
                                                    <th className="text-left">เมนูจัดการ</th>
                                                    <th className="text-center wpx-70">
                                                        <label>ทั้งหมด</label><br />
                                                        <input
                                                            className="hpx-20"
                                                            type="checkbox"
                                                            onChange={(e) => { this.select_all_role("all", e.target.checked) }}
                                                            checked={this.state.role_detail.filter(e => e["can_view"] === false || e["can_add"] === false || e["can_edit"] === false || e["can_delete"] === false || e["can_download"] === false || e["can_approved"] === false).length === 0} />
                                                    </th>
                                                    <th className="text-center wpx-70">
                                                        <label>ดู</label><br />
                                                        <input className="hpx-20" type="checkbox" onChange={(e) => { this.select_all_role("can_view", e.target.checked) }} checked={this.state.role_detail.filter(e => e && e["can_view"] === false).length === 0} />
                                                    </th>
                                                    <th className="text-center wpx-70">
                                                        <label>เพิ่ม</label><br />
                                                        <input className="hpx-20" type="checkbox" onChange={(e) => { this.select_all_role("can_add", e.target.checked) }} checked={this.state.role_detail.filter(e => e && e["can_add"] === false).length === 0} />
                                                    </th>
                                                    <th className="text-center wpx-70">
                                                        <label>แก้ไข</label><br />
                                                        <input className="hpx-20" type="checkbox" onChange={(e) => { this.select_all_role("can_edit", e.target.checked) }} checked={this.state.role_detail.filter(e => e && e["can_edit"] === false).length === 0} />
                                                    </th>
                                                    <th className="text-center wpx-70">
                                                        <label>ลบ</label><br />
                                                        <input className="hpx-20" type="checkbox" onChange={(e) => { this.select_all_role("can_delete", e.target.checked) }} checked={this.state.role_detail.filter(e => e && e["can_delete"] === false).length === 0} />
                                                    </th>
                                                    <th className="text-center wpx-70">
                                                        <label>ดาวน์โหลด</label><br />
                                                        <input className="hpx-20" type="checkbox" onChange={(e) => { this.select_all_role("can_download", e.target.checked) }} checked={this.state.role_detail.filter(e => e && e["can_download"] === false).length === 0} />
                                                    </th>
                                                    <th className="text-center wpx-70">
                                                        <label>ยืนยัน</label><br />
                                                        <input className="hpx-20" type="checkbox" onChange={(e) => { this.select_all_role("can_approved", e.target.checked) }} checked={this.state.role_detail.filter(e => e && e["can_approved"] === false).length === 0} />
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {this.state.role_detail.map((item, index) => (
                                                    <tr className={item.title ? "bg-contain" : ""}>
                                                        <td>{item.name_th}</td>
                                                        <td className="text-center">
                                                            {!item.title && (
                                                                <input type="checkbox" onChange={(e) => { this.select_role("all", index) }} checked={item["can_view"] && item["can_add"] && item["can_edit"] && item["can_delete"] && item["can_download"] && item["can_approved"]} />
                                                            )}
                                                        </td>
                                                        <td className="text-center">
                                                            {!item.title && (
                                                                <input type="checkbox" onChange={(e) => { this.select_role("can_view", index) }} checked={item["can_view"]} />
                                                            )} </td>
                                                        <td className="text-center">
                                                            {!item.title && (
                                                                <input type="checkbox" onChange={(e) => { this.select_role("can_add", index) }} checked={item["can_add"]} />
                                                            )}</td>
                                                        <td className="text-center">
                                                            {!item.title && (
                                                                <input type="checkbox" onChange={(e) => { this.select_role("can_edit", index) }} checked={item["can_edit"]} />
                                                            )} </td>
                                                        <td className="text-center">
                                                            {!item.title && (
                                                                <input type="checkbox" onChange={(e) => { this.select_role("can_delete", index) }} checked={item["can_delete"]} />
                                                            )} </td>
                                                        <td className="text-center">
                                                            {!item.title && (
                                                                <input type="checkbox" onChange={(e) => { this.select_role("can_download", index) }} checked={item["can_download"]} />
                                                            )} </td>
                                                        <td className="text-center">
                                                            {!item.title && (
                                                                <input type="checkbox" onChange={(e) => { this.select_role("can_approved", index) }} checked={item["can_approved"]} />
                                                            )} </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="body w-100 position-fixed bg-white p-3 d-flex align-items-center justify-content-end" style={{ bottom: 0 }}>
                    <button className="btn btn-outline-orange mx-1" onClick={() => { this.setState({ modal_sub_pay: true }) }}>
                        ยกเลิก
                    </button>
                    <button className="btn btn-orange mx-1" onClick={() => {
                        if (this.props.location.query.id) {
                            this.Update();
                        } else {
                            this.Create();
                        }
                    }}>
                        บันทึก
                    </button>
                </div>
            </div >
        )
    }
}
